module.exports = __webpack_public_path__ + "static/media/like-icon-hover.479fc629.svg";